import React from 'react';
import { Route, Routes } from 'react-router-dom';
import FinanceDashboard from '../../../Dashboards/Finance/index';
import FinanceDashboardEdit from '../../../Dashboards/FinanceTableEdit/index';

export default () => (
  <Routes>
    <Route path="/finance_dashboard" element={<FinanceDashboard />} />
    <Route path="/finance_dashboard/edit/:index" element={<FinanceDashboardEdit />} />
  </Routes>
);
